var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 10C8.00008 10.3682 7.7016 10.6667 7.33341 10.6667C6.96522 10.6667 6.66675 10.3682 6.66675 10C6.66675 9.63185 6.96522 9.33337 7.33341 9.33337C7.7016 9.33337 8.00008 9.63185 8.00008 10Z",
    fill: "#1A1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10C10.6667 10.3682 10.3683 10.6667 10.0001 10.6667C9.63189 10.6667 9.33341 10.3682 9.33341 10C9.33341 9.63185 9.63189 9.33337 10.0001 9.33337C10.3683 9.33337 10.6667 9.63185 10.6667 10Z",
    fill: "#1A1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10C13.3334 10.3682 13.0349 10.6667 12.6667 10.6667C12.2986 10.6667 12.0001 10.3682 12.0001 10C12.0001 9.63185 12.2986 9.33337 12.6667 9.33337C13.0349 9.33337 13.3334 9.63185 13.3334 10Z",
    fill: "#1A1919"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99992,
    cy: 10,
    r: 6.66667,
    stroke: "#1A1919",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIco);
export default __webpack_public_path__ + "static/media/more-ico.e57dcce8f5b4fd21d42e7178a2d51804.svg";
export { ForwardRef as ReactComponent };